// A cited block's outline on its page, normalized to [0, 1] from the top-left corner, as olio-api
// stores it on a citation's `highlights`. Lives with the models so a model can parse it without
// importing a component.
export type CitationHighlight = { page: number; x: number; y: number; w: number; h: number };

const isPage = (value: unknown): value is number => Number.isInteger(value) && (value as number) > 0;
const isUnit = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= 1;

// Stored JSON is only as good as whatever wrote it — a value from before the api validated these, or
// one patched by hand — so both are re-checked where they are read rather than cast. Undefined when
// absent, which readers already treat as "open at the document's first page, nothing outlined".
export function parseCitationPages(value: unknown): number[] | undefined {
  return Array.isArray(value) ? value.filter(isPage) : undefined;
}

export function parseCitationHighlights(value: unknown): CitationHighlight[] | undefined {
  if (!Array.isArray(value)) return undefined;
  return value.filter(
    (h): h is CitationHighlight =>
      typeof h === 'object' &&
      h !== null &&
      isPage(h.page) &&
      isUnit(h.x) &&
      isUnit(h.y) &&
      isUnit(h.w) &&
      isUnit(h.h) &&
      h.w > 0 &&
      h.h > 0
  );
}
